import Vue from 'vue'
import Router from 'vue-router'
import { publicRoute, protectedRoute } from './config'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '../store/index'
const routes = publicRoute.concat(protectedRoute)

Vue.use(Router)
const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: routes,
})

// router gards
router.beforeEach((to, from, next) => {
  let shouldProceed = true
  try {
    if (to.path.search('auth') === -1 && to.meta.requiresAuth) {
      let token = store.getters.getToken
      if (!token || token === '') shouldProceed = false
    }
  } catch (e) {
    shouldProceed = false
  }

  NProgress.start()

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  if (shouldProceed) {
    next()
  } else {
    next({ name: 'login' })
  }
  //auth route is authenticated
  // next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
